const PREFIX = '/v1/CollectiveProject/CommunityHouse'

export const URL = {
  ADD: PREFIX + '/add',
  DEL: PREFIX + '/delete',
  EDIT: PREFIX + '/edit',
  LIST: PREFIX + '/list',
  DETAIL: PREFIX + '/view',
  ENABLE: PREFIX + '/able',
  DISABLE: PREFIX + '/disable',
  ORDER: PREFIX + '/order',
  TPL: PREFIX + '/importTemplet',
  IMPORT: PREFIX + '/import'
}
